import React from 'react';
import { COLLECTION_MOCKUP } from '../data/collection';
interface CollectionMockupProps {
  priority?: boolean;
  className?: string;
}

/** The complete collection mockup, shown whole at its natural proportion. */
export function CollectionMockup({
  priority = false,
  className = ''
}: CollectionMockupProps) {
  const {
    src,
    alt,
    width,
    height
  } = COLLECTION_MOCKUP;
  const priorityProps = priority ? {
    fetchpriority: 'high'
  } as Record<string, string> : {};
  return <div className={`mx-auto w-full max-w-[600px] ${className}`} data-id="element-55" data-mp="2x3tyqgpyx7yu">
      <img src={src} alt={alt} width={width} height={height} loading={priority ? 'eager' : 'lazy'} decoding={priority ? 'sync' : 'async'} {...priorityProps} className="block h-auto w-full object-contain" style={{
      aspectRatio: `${width} / ${height}`
    }} data-id="element-56" data-mp="2x5ewsgbhr91g" />
    </div>;
}